import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {Action, Store} from '@ngrx/store';
import {filter, map} from 'rxjs/operators';
import * as actionsUi from './veranstaltungstyp-auswahl.actions.ui';
import {PageState} from './veranstaltungstyp-auswahl.reducer';
import {DatenquelleVeranstaltungsTypen} from './veranstaltungstyp-auswahl.model';
import {GetMitteilungsVorlageVeranstaltungsTypenAction} from '../../../client-ngrx/kommunikation';
import {GetVeranstaltungsTypenAdminAction} from '../../../client-ngrx/veranstaltungen';
import {GetVeranstaltungsTypenAktivAction} from '../../../client-ngrx/veranstaltungstypen';


@Injectable()
export class VeranstaltungstypAuswahlPageUiEffects {

    pageResetKommunikation$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , filter((x: actionsUi.PageStateResetAction | actionsUi.RefreshDataAction) => x.datenquelle === DatenquelleVeranstaltungsTypen.Kommunikation)
        , map(() => {
            return new GetMitteilungsVorlageVeranstaltungsTypenAction();
        })
    ));

    pageResetVeranstaltungen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , filter((x: actionsUi.PageStateResetAction | actionsUi.RefreshDataAction) => x.datenquelle === DatenquelleVeranstaltungsTypen.Veranstaltungen)
        , map(() => {
            return new GetVeranstaltungsTypenAdminAction();
        })
    ));

    pageResetVeranstaltungstypen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(actionsUi.PAGE_STATE_RESET, actionsUi.REFRESH_DATA)
        , filter((x: actionsUi.PageStateResetAction | actionsUi.RefreshDataAction) => x.datenquelle === DatenquelleVeranstaltungsTypen.VeranstaltungsTypen)
        , map(() => {
            return new GetVeranstaltungsTypenAktivAction();
        })
    ));

    constructor(private actions$: Actions,
                private store: Store<PageState>) {
    }
}
